/** Split top-level action items into "today" (due or carried) and "resting"
 *  (future-dated or not yet given a day). Same convention TodayCard has
 *  always used — extracted so the peek list can show resting contents. */
export function splitTodayTasks<
  T extends { dueDate?: number | null; parentId?: string | null }
>(items: T[], eod: number): { today: T[]; resting: T[] } {
  const topLevel = items.filter((it) => !it.parentId);
  const isDue = (it: T) => it.dueDate != null && Number(it.dueDate) <= eod;
  return {
    today: topLevel.filter(isDue),
    resting: topLevel.filter((it) => !isDue(it)),
  };
}
